import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "refer-content" };
const _hoisted_2 = { class: "code-section" };
const _hoisted_3 = { class: "code-field" };
const _hoisted_4 = { class: "code-value" };
const _hoisted_5 = { class: "copy-btn" };
import { ref, computed, watch } from 'vue';
import SimpleDrawerPanel from './elements/SimpleDrawerPanel.vue';
import MGButton from './elements/MGButton.vue';
import { useReferrals } from '@/composables/useReferrals';
import { useAppState } from '@/composables/useAppState';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ReferMGMPage',
    props: {
        modelValue: { type: Boolean }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const open = computed({
            get: () => props.modelValue,
            set: (v) => emit('update:modelValue', v),
        });
        const { referralCode, referrerCredit, refereeCredit, destinationLink, getReferrals } = useReferrals();
        const state = useAppState();
        const copied = ref(false);
        // Fetch the code (generates one server-side if needed) when the sheet opens.
        watch(() => props.modelValue, (isOpen) => {
            if (isOpen)
                getReferrals();
        });
        async function copyCode() {
            if (!referralCode.value)
                return;
            try {
                await navigator.clipboard.writeText(referralCode.value);
                copied.value = true;
                setTimeout(() => { copied.value = false; }, 1500);
            }
            catch (err) {
                console.error('Copy failed', err);
            }
        }
        function formatMoney(amount) {
            return '£' + Number(amount).toFixed(0);
        }
        /* buildShareImage — kept for future use (image sharing removed per client request)
        async function buildShareImage(): Promise<File | null> {
            const img = heroImgRef.value
            if (!img?.complete || !img.naturalWidth) return null
            try {
                const W = img.naturalWidth
                const H = img.naturalHeight
                const canvas = document.createElement('canvas')
                canvas.width = W
                canvas.height = H
                const ctx = canvas.getContext('2d')!
                ctx.drawImage(img, 0, 0)
        
                ctx.fillStyle = '#ffffff'
        
                // "Give" label + amount (matches CSS: left 10%, top 32%)
                ctx.font = `${Math.round(H * 0.027)}px sans-serif`
                ctx.fillText('Give', W * 0.10, H * 0.32)
                ctx.font = `bold ${Math.round(H * 0.072)}px sans-serif`
                ctx.fillText(formatHeroMoney(referrerCredit.value), W * 0.10, H * 0.32 + Math.round(H * 0.085))
        
                // "Get" label + amount (matches CSS: left 32%, top 54%)
                ctx.font = `${Math.round(H * 0.027)}px sans-serif`
                ctx.fillText('Get', W * 0.32, H * 0.54)
                ctx.font = `bold ${Math.round(H * 0.072)}px sans-serif`
                ctx.fillText(formatHeroMoney(refereeCredit.value), W * 0.32, H * 0.54 + Math.round(H * 0.085))
        
                const blob = await new Promise<Blob | null>(resolve => canvas.toBlob(resolve, 'image/jpeg', 0.85))
                if (!blob) return null
                const file = new File([blob], 'money-guided.jpg', { type: 'image/jpeg' })
                return navigator.canShare?.({ files: [file] }) ? file : null
            } catch {
                return null
            }
        }
        */
        async function share() {
            const link = destinationLink.value || 'https://www.moneyguided.com';
            const amount = formatMoney(referrerCredit.value);
            const employer = state.employer?.name || 'your employer';
            const text = `We both have access to Money Guided through ${employer}. I'm using it and thought you might want to as well! 👋\n\n` +
                `Use my invite code when signing up:\n\n${referralCode.value || ''}\n\n` +
                `We'll both receive ${amount} in our Saved to Spend pots once you're in 🎉\n\n` +
                `Download the app and get started here:\n\n${link}`;
            try {
                if (navigator.share) {
                    // const file = await buildShareImage()
                    // await navigator.share({ text, ...(file ? { files: [file] } : {}) })
                    await navigator.share({ text });
                }
                else {
                    await navigator.clipboard.writeText(text);
                }
            }
            catch (err) {
                if (err.name !== 'AbortError') {
                    console.error('Share failed', err);
                }
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(SimpleDrawerPanel, {
                modelValue: open.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((open).value = $event)),
                title: "Invite a colleague",
                closeButton: true,
                divider: false
            }, {
                footer: _withCtx(() => [
                    _createVNode(MGButton, {
                        text: "Share code & instructions",
                        arrow: true,
                        fullWidth: true,
                        noCaps: true,
                        onClick: share
                    })
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(referralCode) || '—'), 1),
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(MGButton, {
                                        small: "",
                                        textOnly: "",
                                        noCaps: "",
                                        text: copied.value ? 'Copied' : 'Copy',
                                        onClick: copyCode
                                    }, null, 8, ["text"])
                                ])
                            ]),
                            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "code-help" }, "Share this code with a colleague to use during sign up. You’ll both receive your Saved to Spend once they complete sign up.", -1))
                        ])
                    ])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
